import { useState } from "react";
import "./HotBooks.css";

/**
 * 도서관 정보나루에서 받은 책 한 권의 소개 칸.
 *
 * 홈의 '도서관 대출 급상승 책' 과 책 화면의 '함께 빌린 책' 이 함께 쓴다.
 * 둘이 같은 정보(소개글·출판사·연령별 대출)를 보여주는데 따로 두면 한쪽만
 * 고쳐져 모양이 어긋난다.
 *
 * 소개글은 자르지 않는다. 다섯 줄로 잘랐더니 급상승 책 15권 중 14권이 잘렸다.
 * 1,000자가 넘는 긴 것만 앞부분을 보이고 '… 더 보기' 로 편다.
 * children 에는 아래 버튼들(담기·무루에서 보기)을 넣는다.
 */
const LONG = 260;
const HEAD = 200;
function headOf(text) {
  const cut = text.slice(0, HEAD);
  const end = Math.max(cut.lastIndexOf("다. "), cut.lastIndexOf(". "), cut.lastIndexOf("? "));
  if (end > HEAD * 0.5) return cut.slice(0, end + 2).trim();
  const sp = cut.lastIndexOf(" ");
  return (sp > HEAD * 0.5 ? cut.slice(0, sp) : cut).trim();
}
const comma = (n) => Number(n).toLocaleString("ko-KR");

export default function LibraryBookDetail({ book: b, children, hideEmpty = false }) {
  const [full, setFull] = useState(false);
  const top = b.ages?.length ? Math.max(...b.ages.map((a) => a.cnt)) : 0;
  const meta = [b.publisher, b.year, b.cls?.split(" > ").pop()].filter(Boolean).join(" · ");

  return (
    <div className="hb-more">
      {b.desc && (b.desc.length <= LONG ? (
        <p className="hb-desc">{b.desc}</p>
      ) : (
        <p className="hb-desc">
          {full ? b.desc : headOf(b.desc)}
          <button className="hb-expand" onClick={() => setFull((v) => !v)} aria-expanded={full}>
            {full ? "접기" : "… 더 보기"}
          </button>
        </p>
      ))}
      {!b.desc && !hideEmpty && <p className="hb-desc hb-desc-none">도서관에 소개글이 없는 책이에요</p>}

      {meta && <div className="hb-meta">{meta}</div>}

      {/* 전체 대출은 신간처럼 아직 집계 전인 책에는 없다. 있을 때만. */}
      {b.loanTotal ? (
        <div className="hb-total">전국 도서관 대출 <b>{comma(b.loanTotal)}</b>건</div>
      ) : null}

      {b.ages?.length ? (
        <div className="hb-ages">
          {b.ages.map((a) => (
            <div className="hb-age" key={a.name}>
              <span className="hb-age-n">{a.name}</span>
              <span className="hb-age-bar"><i style={{ width: `${top ? Math.round((a.cnt / top) * 100) : 0}%` }} /></span>
              <span className="hb-age-c">{comma(a.cnt)}</span>
            </div>
          ))}
        </div>
      ) : null}

      {children ? <div className="hb-actions">{children}</div> : null}
    </div>
  );
}
